import {
  calculateFrameSize,
  calculateMinimumSaddleHeight,
  calculateMaximumSaddleHeight,
  calculateMaximumStandoverHeight,
  calculateHandlebarWidth,
  calculateMinimumSaddleWidth,
  calculateMaximumSaddleWidth,
  calculateUpperBody,
  calculateTopTubeStemCombination,
  calculateSoftScore,
  reachFromTTS,
  stackFromInseam
} from '../../../lib/fitkit-js-functions-v3'

import { calculateSeatTubeAngle } from '../../../lib/seat-tube-angles.mjs'

import { calculateAge } from '../../../utils/dateFormats'

const useSizingRecommendations = (bodyMeasurements, softScores, birthDate) => {
  const { footLength, inseam, torso, arm, shoulders, sitBones } =
    bodyMeasurements

  const { ridingStyle, flexibility, preconditions } = softScores

  const age = calculateAge(birthDate)

  const frameSize = calculateFrameSize(inseam)
  const minSaddleHeight = calculateMinimumSaddleHeight(frameSize, footLength)
  const maxSaddleHeight = calculateMaximumSaddleHeight(frameSize, footLength)
  const maxStandoverHeight = calculateMaximumStandoverHeight(inseam)
  const handlebarWidth = calculateHandlebarWidth(shoulders)
  const minSaddleWidth = calculateMinimumSaddleWidth(sitBones)
  const maxSaddleWidth = calculateMaximumSaddleWidth(sitBones)
  const upperBody = calculateUpperBody(torso, arm)
  const softScore = calculateSoftScore(
    age,
    ridingStyle,
    flexibility,
    preconditions
  )
  const topTubeAndStemDropBar = calculateTopTubeStemCombination(
    upperBody,
    0,
    'Drop',
    true
  )
  const topTubeAndStemFlatBar = calculateTopTubeStemCombination(
    upperBody,
    0,
    'Flat'
  )
  const topTubeAndStemAeroBar = topTubeAndStemDropBar - 2

  const AdjustedTopTubeAndStemDropBar = calculateTopTubeStemCombination(
    upperBody,
    softScore,
    'Drop',
    true
  )
  const AdjustedTopTubeAndStemFlatBar = calculateTopTubeStemCombination(
    upperBody,
    softScore,
    'Flat'
  )
  const AdjustedTopTubeAndStemAeroBar = AdjustedTopTubeAndStemDropBar - 2

  const seatTubeAngle = calculateSeatTubeAngle()

  const reachRange = reachFromTTS(AdjustedTopTubeAndStemDropBar, 90, 110)

  const stackRange = stackFromInseam(inseam)

  return {
    frameSize,
    minSaddleHeight,
    maxSaddleHeight,
    maxStandoverHeight,
    handlebarWidth,
    minSaddleWidth,
    maxSaddleWidth,
    topTubeAndStemDropBar,
    topTubeAndStemFlatBar,
    topTubeAndStemAeroBar,
    AdjustedTopTubeAndStemDropBar,
    AdjustedTopTubeAndStemFlatBar,
    AdjustedTopTubeAndStemAeroBar,
    seatTubeAngle,
    reachRange,
    stackRange
  }
}

export default useSizingRecommendations
